<aside class="sidebar" [class.is-open]="isOpen">
  <!-- Logo (only visible when open) -->
  @if(isOpen){
    <div class="sidebar-logo">
      <img src="assets/images/logo-ribera.svg" alt="Ribera del Río" class="logo-img"
        onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'"/>
      <div class="logo-fallback" style="display:none">
        <span class="logo-text">RIBERA</span>
      </div>
    </div>
  }

  <!-- Section label -->
  <div class="section-label">{{ title()}}</div>

  <!-- EL groupItemsActions se inyecta desde el componente en caso existan opciones especiales 
   determinadas por el componente que lo hace mas flexible para los demás menús se mantiene 
   la misma estructura jerarquica -->
  @if (navitationActionsService.actionsNavigation()) {
  <button class="volver-btn" type="button" id="btn-volver" (click)="returnActionsToComponent()">
    <span class="volver-icon">
      <img src="/products/back_navigation.svg" alt="">
    </span>
    <span class="volver-label">Volver</span>
  </button>

    <nav class="nav-list">
      @for (item of navitationActionsService.actionsNavigation()?.itemsActions; track item.id) {
          <a
          class="nav-item"
          [class.nav-item--active]="isActiveNavigationOrAction(item)"
          (click)="selectedAction(item)"
        >
          <span class="nav-icon" [innerHTML]="getIcon(item.icon)"></span>
          <span class="nav-label">{{ item.label }}</span>
        </a>
        }
    </nav>
  }

  @else if (activeModule() && itemsActions().length > 0) {
  <button class="volver-btn" type="button" id="btn-volver" (click)="returnActions()">
    <span class="volver-icon">
      <img src="/products/back_navigation.svg" alt="">
    </span>
    <span class="volver-label">Volver</span>
  </button>

    <nav class="nav-list">
      @for (item of itemsActions(); track item.id) {
          <a
          class="nav-item"
          [class.nav-item--active]="isActive(item.id)"
          (click)="onContextItemClick(item)"
        >
          <span class="nav-icon" [innerHTML]="getIcon(item.icon)"></span>
          <span class="nav-label">{{ item.label }}</span>
        </a>
        }
    </nav>
  }


  @else if (activeModule()) {
  <button class="volver-btn" type="button" id="btn-volver" (click)="return()">
    <span class="volver-icon">
      <img src="/products/back_navigation.svg" alt="">
    </span>
    <span class="volver-label">Volver</span>
  </button>

    <nav class="nav-list">
      @for (item of activeModule()?.subItems; track item.id) {
        <a
          class="nav-item"
          (click)="navigateSubItemActions(item)"
          [routerLink]="item.itemsActions && item.itemsActions.length > 0 ? item.path : item.path"
          routerLinkActive="nav-item--active"
        >
          <span class="nav-icon" [innerHTML]="getIcon(item.icon)"></span>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      }
    </nav>
  }@else {
    <!-- Nav items -->
    <nav class="nav-list">
      @for (item of navItems(); track item.id) {
        <a
          [routerLink]="item.landingPath ?? (item.subItems && item.subItems.length > 0 ? item.subItems[0].path : item.path)"
          class="nav-item"
          routerLinkActive="nav-item--active"
        >
          <span class="nav-icon" [innerHTML]="getIcon(item.icon)"></span>
          <span class="nav-label">{{ item.label }}</span>
        </a>
      }
    </nav>
  }

  @if (activeModule()?.label?.toLowerCase() === 'ventas'.toLowerCase()) {
    <div class="sidebar-footer nav-item--danger">
      <button class="nav-item footer nav-item--danger" id="nav-ventas-anular" type="button">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
        </span>
        <span class="nav-label">Anular venta</span>
      </button>
    </div>
  }

  <!-- Logout -->
  @if (!activeModule()) {
  <div class="sidebar-footer nav-item--logout" (click)="onLogout()">
    <button class="nav-item footer nav-item--logout " id="btn-logout" type="button" >
      <span class="nav-icon">
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.8999 5.57C7.2099 1.97 9.0599 0.5 13.1099 0.5H13.2399C17.7099 0.5 19.4999 2.29 19.4999 6.76V13.28C19.4999 17.75 17.7099 19.54 13.2399 19.54H13.1099C9.0899 19.54 7.2399 18.09 6.9099 14.55" fill="none"/>
        <path d="M6.8999 5.57C7.2099 1.97 9.0599 0.5 13.1099 0.5H13.2399C17.7099 0.5 19.4999 2.29 19.4999 6.76V13.28C19.4999 17.75 17.7099 19.54 13.2399 19.54H13.1099C9.0899 19.54 7.2399 18.09 6.9099 14.55" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.9991 10.0078H1.61914" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.85 6.65625L0.5 10.0063L3.85 13.3563" fill="none"/>
        <path d="M3.85 6.65625L0.5 10.0063L3.85 13.3563" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="nav-label">Cerrar sesión</span>
    </button>
  </div>
  }
  
</aside>
